import createModule from "../createModule"
import view from "./view"
import { get } from "lodash"
import withUrlParams from "hocs/withUrlParams"
import { Creators } from "model/hookUpdater"
import { getRole } from "helpers/permissions/roles"
import { getTeamId, getTeamRole, getAccountMembers, getTeamMembers, getTabs, getTeamAlias } from "./selectors"

import "./styles.scss"

export default withUrlParams(createModule({
  view,
  externalProps: (state, props) => ({
    account: state.global.selected.account,
    teamAlias: getTeamAlias(state, props),
  }),
  required: ["account", "teamAlias"],
  data: [{
    resource: "members",
    url: () => {
      return {
        query: `{
          members {
            id
            email
            name
            role
            createdAt
            updatedAt
            isActivated
          }
        }`,
      }
    },
  }, {
    resource: "teamMembers",
    passthrough: true,
    url: ({ teamAlias }) => {
      return {
        id: `team-members-${teamAlias}`,
        query: `query ($teamId: IdOrAlias!) {
          team (id: $teamId) {
            id
            name
            role
            members {
              id
              email
              name
              teamRole
              createdAt
              updatedAt
            }
          }
        }`,
        variables: {
          teamId: teamAlias,
        },
      }
    },
  }],
  mapStateToProps: (state, props) => ({
    userId: get(state, "user.id"),
    role: getRole(state),
    teamId: getTeamId(state, props),
    teamRole: getTeamRole(state, props),
    accountMembers: getAccountMembers(state, props),
    teamMembers: getTeamMembers(state, props),
    tabs: getTabs(state, props),
  }),
  actions: {
    ...Creators,
  },
}))
